"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const assets_1 = require("~/assets");
const ErrorModal_1 = __importDefault(require("./ErrorModal"));
function NotFoundModal() {
    const { t } = (0, react_i18next_1.useTranslation)('errors');
    return (react_1.default.createElement(ErrorModal_1.default, { icon: assets_1.svgNotFound, header: t('not-found.error-header'), messages: [t('not-found.nothing-found'), t('not-found.try-anything-else')], imgClassName: "not_found" }));
}
exports.default = NotFoundModal;
